module.exports = [{"UID":"VPP_Marbles_Sand","channel":"VPP_Marbles_Sand","state":"DISABLED","type":"racing","name":"Marbles","brand":"1.0","config":"<xml>dsdf</xml>","displayOrder":1,"category":{"name":"Marble Racing","assetsFolder":"marblesSand"},"URL":{"BMS_ASSETS":"marblesSand"},"options":{}}]


//////////////////
// WEBPACK FOOTER
// ./src/constants/configurations/disabledGamesConfig.json
// module id = 626
// module chunks = 0